module.exports = __webpack_public_path__ + "fonts/SFUIText-Regular.ec32248d.eot";